fragment AiSearchResultFragment on AiSearchResult {
    intent
    suggestions {
        type
        label
        description
        path
        actionId
    }
    searchRefinement
}
